import { logWarn } from '@web-platform/shared-universal-utils-frontend/src/helpers/logger';

import type { PageGroup } from '@web-platform/shared-universal-constants/src/pageGroups';

export type ViewPage =
  'home' | 'combined-results' | 'combined-explore' | 'flights-provider-selection' | 'explore-ai';

type BuildViewPageContextParams = {
  analyticsPage: ViewPage;
  pageGroup: PageGroup;
  origin?: string;
  destination?: string;
};

// Page name + url. Literals match the server's setAnalyticsFields (buildViewEvent.ts:20-43).
export const buildViewPageContext = ({
  analyticsPage,
  destination,
  origin,
  pageGroup,
}: BuildViewPageContextParams) => {
  switch (analyticsPage) {
    case 'combined-results':
      if (!origin || !destination) {
        logWarn({
          component: 'buildViewPageContext',
          message: 'Missing origin/destination for combined-results view event',
        });
        return {
          ancillary: 'airli',
          analyticsPageName: 'day-view',
          gaPageView: '',
          pageType: pageGroup,
        };
      }
      return {
        ancillary: 'airli',
        analyticsPageName: 'day-view',
        gaPageView: `/day-view/${origin}/${destination}/`,
        pageType: pageGroup,
      };
    case 'flights-provider-selection':
      if (!origin || !destination) {
        logWarn({
          component: 'buildViewPageContext',
          message: 'Missing origin/destination for flights-provider-selection view event',
        });
        return {
          ancillary: 'airli',
          analyticsPageName: 'flights-provider-selection',
          gaPageView: '',
          pageType: pageGroup,
        };
      }
      return {
        ancillary: 'airli',
        analyticsPageName: 'flights-provider-selection',
        gaPageView: `/flights-provider-selection/${origin}/${destination}/`,
        pageType: pageGroup,
      };
    case 'combined-explore':
      return {
        ancillary: 'airli',
        analyticsPageName: 'combined-explore',
        gaPageView: '/combined-explore',
        pageType: pageGroup,
      };
    case 'explore-ai':
      return {
        ancillary: '',
        analyticsPageName: 'explore-ai',
        gaPageView: '',
        pageType: pageGroup,
      };
    case 'home':
    default:
      return { ancillary: 'airli', analyticsPageName: 'home', gaPageView: '', pageType: pageGroup };
  }
};
